import React from 'react';
import { Steps, Typography, Button } from 'antd';
import { DollarCircleOutlined, TeamOutlined } from '@ant-design/icons';
import styles from './styles/config-header.module.scss';

const { Title } = Typography;

const ConfigHeader = ({ isFirstTimeSetUp, currentStep = 0, onStepChange }) => {
    // Define the steps based on the configuration type
    const getSteps = () => {
        if (isFirstTimeSetUp) {
            // First time setup steps
            return [
                {
                    title: 'User Eligibility'
                },
                {
                    title: 'Available Balance'
                },
                {
                    title: 'Fee Structure'
                },
                {
                    title: 'Limits'
                }
            ];
        }
        return [];
    };

    const getTitle = () => {
        if (isFirstTimeSetUp) {
            const stepTitles = ['User Eligibility Configuration', 'Available Balance Configuration', 'Fee Structure Configuration', 'Limits Configuration'];
            return stepTitles[currentStep] || 'Configuration Set Up Complete';
        }
        return 'Your EWA Configurations';
    };

    const steps = getSteps();

    const handleTabClick = (index) => {
        if (!isFirstTimeSetUp && onStepChange) {
            onStepChange(index);
        }
    };

    const tabs = [
        {
            key: 0,
            icon: <TeamOutlined />,
            label: 'User eligibility'
        },
        {
            key: 1,
            icon: <DollarCircleOutlined />,
            label: 'Available balance'
        },
        {
            key: 2,
            icon: <DollarCircleOutlined />,
            label: 'Fee Structure'
        },
        {
            key: 3,
            icon: <DollarCircleOutlined />,
            label: 'Limits'
        }
    ];

    return (
        <div className={`${styles.configHeader} ${!isFirstTimeSetUp ? styles.configHeaderLeft : ''}`}>
            <div className={`${styles.titleContainer} ${!isFirstTimeSetUp ? styles.titleContainerLeft : ''}`}>
                <Title level={2} className={styles.title}>
                    {getTitle()}
                </Title>
            </div>
            {isFirstTimeSetUp ? (
                <div className={styles.stepsContainer}>
                    <Steps
                        current={currentStep}
                        items={steps}
                        className={styles.steps}
                        size="default"
                        direction="horizontal"
                        labelPlacement="vertical"
                        progressDot={true}
                    />
                </div>
            ) : (
                <div className={styles.tabsContainer}>
                    <div className={styles.tabs}>
                        {tabs.map((tab) => (
                            <Button
                                key={tab.key}
                                type="default"
                                size="default"
                                icon={tab.icon}
                                onClick={() => handleTabClick(tab.key)}
                                className={`${styles.tab} ${currentStep === tab.key ? styles.tabActive : ''}`}>
                                {tab.label}
                            </Button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ConfigHeader;
